import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5406d524"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "bind-phone-num-page-root main-scroll-topbar-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-text-title"
}, "手机号码", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-text-title"
}, "验证码", -1));

const _hoisted_4 = {
  class: "verify-code-wrapper"
};
const _hoisted_5 = {
  class: "user-agree"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("同意");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("《用户服务协议》");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("及");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("《隐私政策》");

const _hoisted_10 = {
  class: "submit-btn-wrapper"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("登录 / 注册");

import { ref, onBeforeMount, onMounted } from "vue";
import { Toast } from "vant";
import AV from "../assets/utils/av";
import { browserType, jsonify } from "../assets/utils/common.utils";
import router from "../router";
import TopNavigator from "../components/TopNavigator.vue";
import { appID, redirectUriWx } from "../common.config";
import { useRoute } from "vue-router";
import dayjs from "dayjs";
export default {
  __name: 'Login',

  setup(__props) {
    const curRouter = useRoute();
    const ruleFormRef = ref(null);
    const phoneNumReg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
    const verifyCodeReg = /^[0-9]{6}$/;
    const phoneNum = ref("");
    const verifyCode = ref("");
    const codeDisable = ref(false);
    const secondNum = ref(60);
    onBeforeMount(() => {});
    onMounted(() => {}); // 发送验证码

    const requestVerfyCode = () => {
      ruleFormRef.value.validate("phoneNum").then(res => {
        AV.Cloud.requestSmsCode("+86" + phoneNum.value).then(user => {
          countDownFun();
          Toast.success("已发送！");
        }).catch(error => {
          console.error("err: ", error);
          console.error("err.code: ", error.code);

          if (error.code == 601) {
            if (error.message && (error.message.match("过快") || error.message.match("fast"))) {
              countDownFun();
              Toast.fail("发送过快\n稍后重试");
            } else if (error.message && error.message.match("限制")) {
              Toast.fail("发送次数\n超过限制");
            } else {
              Toast.fail("短信发送\n超过限制");
            }
          } else if (error.code == 1) {
            if (error.message && (error.message.match("过快") || error.message.match("fast"))) {
              countDownFun();
              Toast.fail("发送过快\n稍后重试");
            } else {
              Toast.fail("发送失败");
            }
          } else {
            Toast.fail("发送失败");
          }
        });
      }).catch(error => {
        console.error("error: ", error);
      });
    }; // 注册、登录


    const agreeChecked = ref(false);

    const handleSubmit = async () => {
      if (!agreeChecked.value) {
        Toast.fail("请勾选同意用户条款");
      } else {
        Toast.loading({
          message: "登录中...",
          duration: 0,
          forbidClick: true
        });
        AV.User.logOut();
        AV.User.signUpOrlogInWithMobilePhone("+86" + phoneNum.value, verifyCode.value).then(user => {
          const userInfo = user.toJSON();
          setUserInfo(user, userInfo);
        }).catch(error => {
          console.error("error: ", error);

          if (error.code == 137) {
            Toast.fail("账号已注册");
          } else {
            Toast.fail("验证码错误！");
          }
        });
      }
    }; // 设置用户基本信息


    const setUserInfo = (user, userInfo) => {
      if (!userInfo.nickName) {
        const len = userInfo.objectId.length;
        const idHash = userInfo.objectId.substring(len - 6);
        user.set("nickName", `用户_${idHash}`);
      }

      if (!userInfo.avatarUrl) {
        user.set("avatarUrl", "https://summit-img.geekpark.net/if2023/none_avatar.png");
      }

      user.save().then(() => {
        var _userInfo$authData;

        Toast.clear();

        if (!(userInfo !== null && userInfo !== void 0 && (_userInfo$authData = userInfo.authData) !== null && _userInfo$authData !== void 0 && _userInfo$authData.weixin) && browserType.versions.wx) {
          const {
            redirectUri
          } = curRouter.query;
          const redirectUriByEncode = redirectUri || encodeURIComponent(redirectUriWx);
          window.location.href = `https://wxauth.geekpark.net?appid=${appID}&redirect_uri=${redirectUriByEncode}&response_type=code&scope=snsapi_base`;
        } else {
          let redirectPath = "/home";
          const {
            redirectFullPath
          } = curRouter.query;

          if (redirectFullPath) {
            redirectPath = redirectFullPath;
          }

          router.replace(redirectPath);
        }
      }).catch(err => {
        console.error("保存用户信息：", err);
        Toast.fail("操作失败\n请重试");
      });
    };

    const countDownFun = () => {
      if (!codeDisable.value) {
        codeDisable.value = true;
      }

      setTimeout(() => {
        if (secondNum.value >= 2) {
          secondNum.value = secondNum.value - 1;
          countDownFun();
        } else {
          codeDisable.value = false;
          secondNum.value = 60;
        }
      }, 1000);
    };

    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      const _component_router_link = _resolveComponent("router-link");

      const _component_van_checkbox = _resolveComponent("van-checkbox");

      const _component_van_form = _resolveComponent("van-form");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "登录 / 注册"
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_form, {
        onSubmit: handleSubmit,
        class: "bind-phone-num-form",
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_hoisted_2, _createVNode(_component_van_field, {
            class: "phone-num-input",
            modelValue: phoneNum.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => phoneNum.value = $event),
            name: "phoneNum",
            placeholder: "填入手机号",
            rules: [{
              required: true,
              pattern: phoneNumReg,
              message: '请填写正确的手机号'
            }]
          }, null, 8, ["modelValue", "rules"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
            class: "verify-code-input",
            modelValue: verifyCode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => verifyCode.value = $event),
            name: "verifyCode",
            placeholder: "填入验证码",
            rules: [{
              required: true,
              pattern: verifyCodeReg,
              message: '请填写正确的验证码'
            }]
          }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_button, {
            class: "verify-code-btn",
            block: "",
            color: "#9EFF34",
            onClick: requestVerfyCode,
            disabled: codeDisable.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(codeDisable.value ? `(${secondNum.value})秒后获取` : "获取验证码"), 1)]),
            _: 1
          }, 8, ["disabled"])])]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_checkbox, {
          modelValue: agreeChecked.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => agreeChecked.value = $event),
          "icon-size": "16px",
          "label-disabled": ""
        }, {
          default: _withCtx(() => [_hoisted_6, _createVNode(_component_router_link, {
            to: "/user-service-agreement"
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          }), _hoisted_8, _createVNode(_component_router_link, {
            to: "/privacy-policy"
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_button, {
          block: "",
          color: "#9EFF34",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })])]),
        _: 1
      }, 512)])], 64);
    };
  }

};